module.exports = new __parcel__URL__("filter-dark.b5e43eff.svg").toString();